module.exports = __webpack_public_path__ + "img/main_masterkong1.6773e4fb.jpg";